import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompsIntegrationEnum } from '../../../navigation/project-valuation/properties-navigation/models/enums/comps-integration-enum';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';

/**
 * Injectable
 */
@Injectable({
  providedIn: 'root'
})
export class PixIntegrationService {
  /**
   * The resource for the PIX integration service
   */
  private _pixIntegrationResource: string;

  /**
   * Constructor
   * @param ais
   * @param httpClient
   */
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) {
    this._pixIntegrationResource = this.appServiceHelper.getServiceEndpoint('pollux.pix.integration.api', 'comps');
  }
  /**
   * Deletes connected comps for a subject property
   * @param subjectPropertyId The subject property ID
   * @param type What should be deleted. (Connected lease, sale, I&E or all searches)
   * @returns An observable with the delete result
   */
  deleteConnectedComps(subjectPropertyId: string, type: CompsIntegrationEnum): Observable<any> {
    return this.httpClient.delete<any[]>(`${this._pixIntegrationResource}?subjectPropertyId=${subjectPropertyId}&compsType=${type}`);
  }

  /**
   * Creates a subject property ID
   * @param propertyId The property ID
   * @param valuationEventId The valuation event ID
   * @returns An observable with the created subject property ID
   */
  createSubjectPropertyId(propertyId: number, valuationEventId: number): Observable<any> {
    return this.httpClient.post<any>(`${this._pixIntegrationResource}/CreateSubjectPropertyId?propertyId=${propertyId}&valuationEventId=${valuationEventId}`, null);
  }

  /**
   * Retrieves the comps response for a subject property
   * @param subjectPropertyId The subject property ID
   * @param compsType The comps response type - sale or lease or I&E
   * @returns An observable with the comps response
   */
  getCompsResponse(subjectPropertyId: string, compsType: CompsIntegrationEnum): Observable<any> {
    return this.httpClient.get<any>(`${this._pixIntegrationResource}/GetCompsResponse?subjectPropertyId=${subjectPropertyId}&responseType=${compsType}`);
  }
}
